import { useEffect, useState } from 'react';
import gtm from 'eco-design-reliance/gtm';
import { useRouter } from 'next/router';

import { Collapse } from 'antd';
import isEmpty from 'lodash/isEmpty';
import Empty from '../Empty';
import Pagination from '../Pagination';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import css from './index.module.scss';

const { Panel } = Collapse;
export default function Supports({ faqs, isMobile = false, onPageChange, currentPage }: any) {
    const { locale } = useRouter();
    const [collapseKey, setCollapseKey] = useState([]);

    const onChange = (keys: any) => {
        // keys 是一个数组，包含当前展开的所有 panel 的 key
        // 判断是展开还是收起
        const previousKeys = collapseKey;
        const newKeys = keys;

        // 找出变化的 key
        let changedKey = null;
        let isOpen = false;

        if (newKeys.length > previousKeys.length) {
            // 展开了一个 panel
            changedKey = newKeys.find((key: any) => !previousKeys.includes(key));
            isOpen = true;
        } else if (newKeys.length < previousKeys.length) {
            // 收起了一个 panel
            changedKey = previousKeys.find((key: any) => !newKeys.includes(key));
            isOpen = false;
        }

        // 更新 collapseKey
        setCollapseKey(newKeys);
        // 发送 gtm 事件

        if (changedKey) {
            if (typeof window !== 'undefined') {
                const searchEntry: any = localStorage.getItem('search_entry');

                const filterItem = faqs?.content?.find((v: any) => v.id === changedKey);
                const finalTitle = filterItem?.content?.title?.replace(/<em>/g, '').replace(/<\/em>/g, '');

                if (filterItem) {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'select_faq',
                        title_name: finalTitle,
                        status: isOpen ? 'open' : 'close',
                        source_method: searchEntry || 'Non Source Method',
                    });
                }
            }
        }
    };

    const renderFaqTitle = (title: any) => {
        return (
            <p
                className="aiSearchFaqTitle"
                dangerouslySetInnerHTML={{
                    __html: title,
                }}
            />
        );
    };

    useEffect(() => {
        if (faqs?.content?.length) {
            setCollapseKey(faqs.content.map((v: any) => v.id));
        }
    }, [faqs]);

    return (
        <>
            {!isEmpty(faqs) ? (
                <div className={css.aiSearchSupportsContainer}>
                    <Collapse
                        bordered={false}
                        activeKey={collapseKey}
                        onChange={onChange}
                        expandIcon={({ isActive }) => (
                            <div
                                style={{
                                    top: '20%',
                                    transform: isMobile
                                        ? isActive
                                            ? 'rotate(-180deg)'
                                            : 'rotate(0deg)'
                                        : isActive
                                        ? 'rotate(0deg)'
                                        : locale === 'sa'
                                        ? 'rotate(90deg)'
                                        : 'rotate(-90deg)',
                                    transition: 'all .3s',
                                    lineHeight: 0,
                                    right: 0,
                                }}
                            >
                                <EFArrowDown />
                            </div>
                        )}
                        expandIconPosition="right"
                        className={`aiSearchSupportsBox site-collapse-custom-collapse`}
                    >
                        {faqs?.content?.map((faq: any) => (
                            <Panel className="site-collapse-custom-panel" header={renderFaqTitle(faq.content?.title)} key={faq.id}>
                                <p className="aiSearchFaqDesc" dangerouslySetInnerHTML={{ __html: faq.content?.description }} />
                            </Panel>
                        ))}
                    </Collapse>
                    {faqs?.total > 8 && (
                        <div className="aiSearchProductsPagination">
                            <Pagination current={currentPage} total={faqs?.total} pageSize={8} onChange={onPageChange} />
                        </div>
                    )}
                </div>
            ) : (
                <Empty isMobile={isMobile} />
            )}
        </>
    );
}
